import nfUpdateTips from './nfUpdateTips.vue'
export default nfUpdateTips